import { render, staticRenderFns } from "./DeparmentAdd.vue?vue&type=template&id=2f37c7ee&"
import script from "./DeparmentAdd.vue?vue&type=script&lang=js&"
export * from "./DeparmentAdd.vue?vue&type=script&lang=js&"
import style0 from "./DeparmentAdd.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports